import React from 'react'
import { MotionImage, MotionSection } from '../motion/Motion'

export default function ContactHero() {
  return (
    <MotionSection className="w-[96%] sm:w-[92%] md:w-[90%] lg:w-[90%] mx-auto -mt-2 sm:-mt-4 lg:-mt-5 py-10 lg:py-14">
      <MotionImage>
        <img
          src="/images/sectionimages/contact%20page.png"
          alt="Contact page"
          className="w-full h-auto object-contain"
        />
      </MotionImage>
    </MotionSection>
  )
}
